//CODE: To Display only two accessories
setTimeout(() => {
  const items = document.querySelectorAll(
    "#accessories-items .accessories-item"
  );
  if (items.length > 2) {
    items.forEach((item, index) => {
      if (index > 1) {
        item.classList.add("accessories-hide");
      }
    });
  }
  // console.log("accessories-items", document.getElementById("accessories-items"));
}, 5000);

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const prices = document.querySelectorAll(".accessory-price");
    prices.forEach((price) => {
      price.textContent = price.textContent.replace(/\$\s+/, "$"); // remove space after $
    });
    const quickViewButtons = document.querySelectorAll(
      ".btn-accessories-quick-view"
    );
    quickViewButtons.forEach((button) => {
      button.addEventListener("click", () => {
        console.log(
          "Quick View button clicked. Waiting for modal to render..."
        );

        // After a click, we wait a short period for the modal animation to finish
        // and for its content to be fully loaded into the page's HTML (DOM).
        // 500ms is usually enough time.
        const prices = document.querySelectorAll(".accessory-modal-price");
        console.log("Found modal prices:", prices);

        prices.forEach((price) => {
          // Removes the space directly after the dollar sign
          price.textContent = price.textContent.replace(/\$\s+/, "$");
        });

        console.log("Modal prices have been formatted."); // A shorter delay provides a better user experience
      });
    });
    const accessoryContainers = document.querySelectorAll(".accessories-right");

  // Loop through each container to restructure its content.
  accessoryContainers.forEach(container => {
    // Find the elements to be moved WITHIN the current container.
    const variantSelect = container.querySelector(".accessory-variant-select");
    const priceDisplay = container.querySelector(".accessory-price");

    // Check if both elements exist to avoid errors.
    if (variantSelect && priceDisplay) {
      // 1. Create the new div that will act as a wrapper.
      const newWrapper = document.createElement("div");
      newWrapper.classList.add("variant-price-wrapper"); // Assign a class for easy styling.

      // 2. Move the select and price elements into the new wrapper.
      // The appendChild() method automatically removes them from their original positions.
      newWrapper.appendChild(variantSelect);
      newWrapper.appendChild(priceDisplay);

      // 3. Place the new wrapper (containing the two elements) back into the main container.
      container.appendChild(newWrapper);
    }
  });


    document.querySelectorAll('.accessory-variant-select').forEach(function(selectElement) {
        function toggleVisibility() {
            var selectedText = selectElement.options[selectElement.selectedIndex].text;
            var selectedBlock = document.querySelector('.accessory-price');
            
            if (selectedText.trim() === 'Default Title' && selectedBlock) {
                selectElement.style.display = 'none';
                selectedBlock.style.display = 'block';
            } else {
                selectElement.style.display = 'block';
                selectedBlock.style.display = 'none';
            }
        }

        // Run once on page load (in case it's already "Default Title")
        toggleVisibility();

        // Re-run whenever the selection changes
        selectElement.addEventListener('change', toggleVisibility);
    });



  }, 5000);
});
// Loop through each button and add a click event listener
// Find all elements with the class "btn-accessories-quick-view"

// Code: Change the Review text on PDP
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const reviewContainer = document.querySelector(
      ".RRPR_src-features-rating_widget-styles__links"
    );
    const writeReview = document.querySelector(
      ".RRPR_src-features-rating_widget-styles__links>div>button"
    );
    // console.log("writeReview", writeReview);
    if(writeReview)
    writeReview.style.display = "none";
    const reviewText = reviewContainer?.querySelector("button");
     if(reviewText)
    reviewText.style.display = "block";
    // console.log("Review container:", reviewContainer);
    // console.log("Review button:", reviewText);

    if (reviewText && reviewText.textContent === "Be the first to review!") {
      reviewText.textContent = "Be the first to review";
      // console.log("no review");
    } else if (reviewText && reviewText.textContent === "Read all 1 reviews") {
      reviewText.textContent = "1 review";
      // console.log("review 1");
    } else if (reviewText) {
      // console.log("has review");
      const match = reviewText.textContent.match(/Read all (\d+) reviews/);
      if (match) {
        const count = match[1];
        reviewText.textContent = `${count} reviews`;
        // console.log(`has review (${count})`);
      } else {
        // console.log("has review (non-standard format)");
      }
    } else {
      // console.log("Button not found");
    }
  }, 1000);
});


